import { createContext, useContext } from 'react';

const invariantViolation = () => {
    throw new Error("Attempted to call useModal outside of modal context. Make sure your app is rendered inside ModalProvider.");
};
const GlobalModalContext = createContext({
    dispatch: invariantViolation,
});
function useGlobalModalContext() {
    return useContext(GlobalModalContext);
}
function reducer(state, action) {
    const { payload, type } = action;
    const id = payload.RenderModal.name;
    switch (type) {
        case "openModal":
            return {
                ...state,
                [id]: {
                    isOpen: true,
                    props: payload.props || {},
                    RenderModal: payload.RenderModal,
                },
            };
        case "closeModal": {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { [id]: _omitted, ...nextState } = state;
            return nextState;
        }
    }
}

export { GlobalModalContext, reducer, useGlobalModalContext };
//# sourceMappingURL=GlobalModalContext.esm.js.map
